import React from "react";
import Modal from "./Modal";
import useModal from "../hooks/useModal";
import "../styles/modal.css";

const FlourishTalentsClub = () => {
  const { isOpen, openModal, closeModal } = useModal();

  return (
    <div className="titles">
      <h2 className="title has-text-centered">Membership</h2>

      <div
        className="image-block top-banner-item center-container my-unique-image-block"
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "1150px",
          margin: "0 auto",
          overflow: "hidden",
          height: "550px",
        }}
      >
        <img
          alt="FlourishTalents Club"
          src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fgalaxy-background.jpg?alt=media&token=307706f1-2bdd-4854-bad5-28937211afae"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        <div className="image-block-inner">
          <div className="top-banner-item-inner">
            <h1 className="title">Join us at FlourishTalents Club</h1>
            <p className="portfoliotext-big">
            Empowering Talent, Elevating Collective Potential
            </p>

            {/* Button to open the modal */}
            <button disabled className="custom-button custom-membership-button">
              <span>About us</span>
            </button>
          </div>
        </div>
      </div>

      {/* Modal Implementation */}
      <Modal isOpen={isOpen} onClose={closeModal}>
        <div style={{ position: "relative", padding: "1rem" }}>
          <button
            onClick={closeModal}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#333",
              fontSize: "1.5rem",
              fontWeight: "bold",
            }}
          >
            &times;
          </button>

          <iframe
            src="/"
            width="100%"
            height="520"
            title="About Us Form"
          >
            Loading…
          </iframe>
        </div>
      </Modal>
    </div>
  );
};

export default FlourishTalentsClub;
